import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-canvas px-4 py-16 sm:px-6 sm:py-20" data-id="element-104" data-mp="1geimufhsgv0a">
      <div className="mx-auto max-w-3xl" data-id="element-105" data-mp="2e0pnjeaz237d">
        <SectionHeading kicker="Frequently asked questions" title="Everything you need to know" data-id="element-106" data-mp="2dyd9vdc8yf04" />

        <div className="mt-10 space-y-3" data-id="element-107" data-mp="28za41qog04r3">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-108" data-mp="1z3ow7bwp0a9f" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-109" data-mp="smv3qjqrqo8k">
                  <span className="font-display text-[17px] font-bold leading-snug text-ink sm:text-lg" data-id="element-110" data-mp="ufpuehd1ztzo">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-111" data-mp="fji9fettmojc" />
                </button>
                <AnimatePresence initial={false} data-id="element-112" data-mp="bjq0h10imgdg">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-113" data-mp="3szze87kzy2qx">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink-soft" data-id="element-114" data-mp="3nz21iaira0wt">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-115" data-mp="1kr1d10vvg6oy">
          <CtaButton label="I'm ready — get the Blueprint" arrow data-id="element-116" data-mp="1ks2z00efedlg" />
        </div>
      </div>
    </section>;
}